import { ApiaUtil, Checkbox, Confirm } from '@apia/components';
import {
  OverrideFieldRow,
  TTrConfirmProps,
} from '../../../components/OverrideFieldRow';
import { confirmNewValues } from './confirmNewValues';
import { Box } from '@apia/theme';
import { getLabel } from '@apia/util';
import { TFieldValue } from './resolveResponseResult';
import { TMessageType } from '@apia/ai';

export const resolveConfirm = (
  fillProps: {
    confirmProps: TTrConfirmProps[];
    confirmedValues: string[];
  },
  formResponse: {
    message: string;
    filledFormsMap: Record<string, Record<string, TFieldValue>>;
    type: TMessageType;
  },
  isPhone: boolean,
) => {
  if (!fillProps.confirmProps?.length) return;
  const listItems = fillProps.confirmProps.map((children) => (
    <OverrideFieldRow {...children} key={children.fieldName} />
  ));
  const modal = ApiaUtil.instance.modals.open({
    title: isPhone
      ? getLabel('msgAiConfirmModalTitlePhone').text
      : getLabel('msgAiConfirmModalTitle').text,
    shouldCloseOnOverlayClick: false,
    size: isPhone ? 'sm' : 'xl-fixed',
    variant: 'layout.ai.execution.formsAssistant.overrideTable',
    children: (
      <form
        action="#"
        onSubmit={(ev) => {
          confirmNewValues(ev, fillProps, formResponse, isPhone);
          modal.close();
        }}
      >
        {isPhone ? (
          <Confirm>
            <Box as="table" id="shouldReplace" className="confirmNewValues">
              <tbody>
                <tr key={'replaceAll'} id={'replaceAll'}>
                  <td
                    data-value={'replaceAll'}
                    title={getLabel('lblAiReplaceAllValues').text}
                  >
                    {getLabel('lblAiReplaceAllValues').text}
                  </td>
                  <td key="action">
                    <Checkbox />
                  </td>
                </tr>
                <tr key={'discardAll'} id={'discardAll'}>
                  <td
                    data-value={'discardAll'}
                    title={getLabel('lblAiDiscardAllValues').text}
                  >
                    {getLabel('lblAiDiscardAllValues').text}
                  </td>
                  <td key="action">
                    <Checkbox />
                  </td>
                </tr>
              </tbody>
            </Box>
          </Confirm>
        ) : (
          <></>
        )}
        <Confirm sx={{ display: isPhone ? 'none' : '' }}>
          <Box as="table" className="confirmNewValues" id="confirmNewValues">
            <thead>
              <tr>
                <th title={getLabel('lblAiFieldName')?.title}>
                  {getLabel('lblAiFieldName')?.text}
                </th>
                <th title={getLabel('lblAiFieldOldValue')?.title}>
                  {getLabel('lblAiFieldOldValue')?.text}
                </th>
                <th title={getLabel('lblAiFieldNewValue')?.title}>
                  {getLabel('lblAiFieldNewValue')?.text}
                </th>
                <th title={getLabel('lblAiFieldAction')?.title}>
                  {getLabel('lblAiFieldAction')?.text}
                </th>
              </tr>
            </thead>
            <tbody>{listItems}</tbody>
          </Box>
        </Confirm>
      </form>
    ),
    onExited() {
      //resolve();
    },
    initialFocusGetter(modalInnerRef) {
      return modalInnerRef.querySelector<HTMLElement>('button[type="submit"]');
    },
  });
};
